import { createApi } from '@reduxjs/toolkit/query/react';
import { updateJobSourcingCampaign } from 'hooks/useJobs/actions';
import deserialize from 'helpers/getroPropertyMapper';
import { networkBaseQueryV2, baseQuery } from './queries';

export const findemApiV2 = createApi({
  reducerPath: 'findemApiV2',
  baseQuery: networkBaseQueryV2,
  tagTypes: ['sourcingCampaigns'],
  endpoints: (builder) => ({
    getFindemAuth: builder.query({
      query: () => ({
        url: `/findem/auth`,
      }),
    }),

    createSourcingCampaign: builder.mutation({
      query: ({ jobId, calibrate }) => ({
        url: `/sourcing_campaigns`,
        method: 'post',
        params: {
          ...(jobId ? { jobId } : {}),
          ...(calibrate !== undefined ? { calibrate } : {}),
        },
      }),
      invalidatesTags: ['sourcingCampaigns'],
      async onQueryStarted({ jobId, calibrate }, { dispatch, queryFulfilled }) {
        try {
          const { data: campaignResponse } = await queryFulfilled;

          // Update the job's sourcing campaign status in the local cache
          if (campaignResponse && jobId) {
            const status = calibrate ? 'calibrating' : 'ready_to_launch';
            dispatch(updateJobSourcingCampaign({ jobId, sourcingCampaign: { status } }));
          }
        } catch {
          // ignore error
        }
      },
      transformResponse: (response) => deserialize(response),
    }),
    syncSourcingCampaign: builder.mutation({
      query: ({ icpId, jobId }) => ({
        url: `/sourcing_campaigns/sync`,
        method: 'post',
        params: {
          ...(icpId ? { icpId } : {}),
          ...(jobId ? { jobId } : {}),
        },
      }),
      invalidatesTags: ['sourcingCampaigns'],
    }),
    updateSourcingCampaign: builder.mutation({
      query: ({ id, icpId, outreachChatSessionId, calibrateChatSessionId, status }) => ({
        url: `/sourcing_campaigns/${id}`,
        method: 'put',
        params: {
          ...(icpId ? { icpId } : {}),
          ...(outreachChatSessionId ? { outreachChatSessionId } : {}),
          ...(calibrateChatSessionId ? { calibrateChatSessionId } : {}),
          ...(status ? { status } : {}),
        },
      }),
      invalidatesTags: ['sourcingCampaigns'],
    }),
    getExternalCalibrationAuth: builder.query({
      queryFn: async ({ collectionId, jobId }, { dispatch, getState }, extraOptions) =>
        baseQuery(
          {
            url: `/collections/${collectionId}/findem/external_calibration_auth`,
            method: 'GET',
            version: 'v2',
            params: {
              jobId,
            },
          },
          { dispatch, getState },
          extraOptions,
        ),
    }),
  }),
});

export const {
  useGetFindemAuthQuery,
  useLazyGetFindemAuthQuery,
  useGetFindemPublicAuthQuery,
  useLazyGetFindemPublicAuthQuery,
  useCreateSourcingCampaignMutation,
  useSyncSourcingCampaignMutation,
  useUpdateSourcingCampaignMutation,
  useGetExternalCalibrationAuthQuery,
  useLazyGetExternalCalibrationAuthQuery,
} = findemApiV2;
